import { background, border, borderRadius, compose, flexbox, get, grid, layout, position, shadow, space, system, typography } from "styled-system";
import { elevation } from "./elevation";

function isNumber(n) {
  return typeof n === "number" && !Number.isNaN(n);
}

export function toPx(n) {
  return isNumber(n) && n !== 0 ? n + "px" : n;
}
export function getPx(n, scale) {
  return toPx(get(scale, n, n));
}
export var textTransform = system({
  textTransform: true
});
export var color = system({
  color: {
    property: "color",
    scale: "colors"
  },
  textColor: {
    property: "color",
    scale: "colors"
  },
  bg: {
    property: "backgroundColor",
    scale: "colors"
  },
  backgroundColor: {
    property: "backgroundColor",
    scale: "colors"
  },
  opacity: true
});
export var allProps = compose(background, border, borderRadius, color, elevation, flexbox, grid, layout, position, shadow, space, textTransform, typography);